import { setTheme } from "theme/default/setTheme";

export const setColor_2b3e50 = setTheme(({ theme }) => `color: ${theme.colors.color_2b3e50}`);
